export default function (originalTitle: string, unreadChatsCount: number = 0) {
  if (unreadChatsCount > 0) {
    document.title = `(${unreadChatsCount}) ${originalTitle}`;
  } else {
    document.title = originalTitle;
  }
}
